export default __webpack_public_path__ + "static/media/agree_to_drop.edbde9fe.svg";